var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { responsiveTextAlignStyle, responsiveTextFont, } from '../../styles/internal';
import { textBaseStyle } from './styles';
const Root = styled.div(responsiveTextFont, responsiveTextAlignStyle, textBaseStyle);
export const Text = forwardRef((props, ref) => {
    const { accent = false, align, children, muted = false, size = 2, weight } = props, restProps = __rest(props, ["accent", "align", "children", "muted", "size", "weight"]);
    return (React.createElement(Root, Object.assign({ "data-ui": "Text" }, restProps, { "$accent": accent, "$align": align, "$muted": muted, ref: ref, "$size": size, "$weight": weight }), children));
});
Text.displayName = 'Text';
//# sourceMappingURL=text.js.map